export default "/assets/site/images/tihanyi_zoltan.png?c69d9fd04a623c7c3b03221d726de1f9";